import * as e from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/KeyReturn.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(n, { ref: t, ...r, weights: a }));
o.displayName = "KeyReturnIcon";
const s = o;
export {
  s as KeyReturn,
  o as KeyReturnIcon
};
